import type { InventoryItem } from '@app/types/shop-bff/types';

/**
 * Returns discounted price amount if discount is applicable.
 */
export const getItemValue = (
  price: NonNullable<InventoryItem['price']>
): number => {
  if (price.discount && price.discount.percent > 0)
    return price.discount.amount;

  return price.amount;
};
